export default __webpack_public_path__ + "static/media/regulatory--truck-speed-limit-85--g1.6125756c.png";